import { mapGetters } from 'vuex'
import { mailAddress } from '@/api/mail'
import journal from '@/api/journal'
import Add from './add.dialog.vue'
import siteTab from '@/components/tab'
import SiteSearchGroup from '@/components/search-group'
const PUBLISHER_BLACKLIST = [
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 120,
    dataIndex: 'Name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Roles',
    width: 200,
    dataIndex: 'roleList',
    slot: 'roles'
  },
  {
    title: '',
    enTitle: 'Note',
    width: 200,
    dataIndex: 'remark',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 120,
    dataIndex: 'operator',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Created Time',
    width: 170,
    dataIndex: 'createTime',
    slot: 'time',
    sort: true
  },
  {
    title: '',
    enTitle: 'Updated Time',
    width: 170,
    dataIndex: 'updateTime',
    slot: 'time',
    sort: true
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
const REVIEWER_UNSUBSCRIBE = [
  {
    title: '',
    enTitle: 'Email',
    width: 150,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 120,
    dataIndex: 'Name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Roles',
    width: 180,
    dataIndex: 'roleList',
    slot: 'roles'
  },
  {
    title: '',
    enTitle: 'Journal',
    width: 180,
    dataIndex: 'journal',
    slot: 'journal'
  },
  {
    title: '',
    enTitle: 'Unsubscribe Date',
    width: 160,
    dataIndex: 'unsubscribeTime',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Release Date',
    width: 150,
    dataIndex: 'expiredTime',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Note',
    width: 300,
    dataIndex: 'remark',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
const SYSTEM_BOUNCE = [
  {
    title: '',
    enTitle: 'Email',
    width: 150,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 120,
    dataIndex: 'Name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Roles',
    width: 180,
    dataIndex: 'roleList',
    slot: 'roles'
  },
  {
    title: '',
    enTitle: 'Note',
    width: 200,
    dataIndex: 'remark',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Created Time',
    width: 120,
    dataIndex: 'createTime',
    slot: 'time',
    sort: true
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 80,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    siteTab,
    SiteSearchGroup,
    Add
  },
  data() {
    return {
      menus: [
        {
          name: 'Publisher Blacklist',
          code: 'SYSTEM.MAIL.CHECKLIST.PUBLISHER_BLACKLIST',
          num: 'publisherBlacklistNum',
          key: 'PUBLISHER_BLACKLIST',
          tooltip: `This is an absolute blacklist of publisher, and they're permanent`
        },
        {
          name: 'Reviewer Unsubscribe',
          code: 'SYSTEM.MAIL.CHECKLIST.REVIEWER_UNSUBSCRIBE',
          num: 'reviewerUnsubscribeNum',
          key: 'REVIEWER_UNSUBSCRIBE',
          tooltip:
            'Reviewers who declined to review will be added to this list.'
        },
        {
          name: 'System Bounced',
          code: 'SYSTEM.MAIL.CHECKLIST.SYSTEM_BOUNCED',
          num: 'systemBouncedNum',
          key: 'SYSTEM_BOUNCE',
          tooltip:
            'These Emails have repeatedly failed to accept mail, And it bounced back more than five times.'
        }
      ],
      columns: {
        PUBLISHER_BLACKLIST,
        REVIEWER_UNSUBSCRIBE,
        SYSTEM_BOUNCE
      },
      journalList: [],
      dataSource: [{}],
      index: 0,
      params: {
        keyword: '',
        type: ''
      },
      count: {
        publisherBlacklistNum: 0,
        reviewerUnsubscribeNum: 0,
        systemBouncedNum: 0
      },
      isVisable: false,
      inputData: {},
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      language: 'getLanguage'
    })
  },
  watch: {
    user: {
      handler() {
        this.getMenus()
      },
      immediate: true
    }
  },
  async mounted() {
    this.getJournal()
    this.getMenus()
    this.getList()
  },
  methods: {
    async getCount() {
      this.count = await mailAddress.getNum(this.params)
    },
    getMenus() {
      this.menus.some((item, index) => {
        if (this.user.codeList && this.user.codeList.includes(item.code)) {
          this.params.type = item.key
          this.index = index
          return true
        }
      })
      // this.params.type = this.params.type || 'PUBLISHER_BLACKLIST'

      this.index = this.index || 0
    },
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })
      const { list, pageIndex, pageSize, total } = await mailAddress.getList(
        data
      )
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
      this.getCount()
    },
    async getJournal() {
      this.journalList = await journal.userGet()
    },
    changeType(val, num) {
      this.params.type = val
      this.index = num
      this.getList()
    },
    add() {
      this.inputData = {}
      this.isVisable = true
    },
    edit(val) {
      this.inputData = val
      this.isVisable = true
    },
    confirm() {
      this.isVisable = false
      this.getList()
    },
    cancel() {
      this.isVisable = false
    },
    async del(val) {
      this.$confirm({
        title: `Delete ${this.menus[this.index].name}`,
        content: `Are you sure you want to delete this Email: ${val.email}?`,
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await mailAddress.delQuery(this.params.type, val.id, {
          journalId: val.journalId
        })
        this.$message.success({
          title: 'Success',
          content: 'Delete successfully!'
        })
        this.getList()
      })
    },
    handleClear() {
      this.params.keyword = ''
      this.getList()
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    }
  }
}
